module.exports = __webpack_public_path__ + "static/img/t32.d7e86e46.png";